(function() {
    let element = document.querySelector('.account-dropdown');

    if (element === null) {
        return;
    }

    element.addEventListener('click', (e) => {
        e.currentTarget.classList.toggle('active');
    });
})();